import gql from 'graphql-tag';

export const PAYMENT_PLANS_BY_ROLE = gql`
  query plans($role: Role) {
    plans(role: $role) {
      planId
      price
      name
      description
      currency
      trial {
        duration
        unit
      }
      addOns {
        amount
        id
        name
        description
        numberOfBillingCycles
      }
      discounts {
        amount
        id
        name
        description
        numberOfBillingCycles
      }
    }
  }
`;

export const BRAINTREE_PLANS_BY_ROLE = gql`
  query braintreePlans($role: Role) {
    braintreePlans(role: $role) {
      planId
      price
      name
      description
      currency
      billingFrequency
      trial {
        duration
        unit
      }
      addOns {
        amount
        id
        name
        description
        numberOfBillingCycles
      }
      discounts {
        amount
        id
        name
        description
        numberOfBillingCycles
      }
      subscriptionStats {
        active
        pastDue
        canceled
        expired
        pending
      }
    }
  }
`;
export const GET_PAYMENT_METHOD_DATA = gql`
  query getPaymentMethodData($subscriptionId: String!) {
    getPaymentMethodData(subscriptionId: $subscriptionId) {
      maskedNumber
      expirationDate
    }
  }
`;

export const ACTIVE_USER_SUBSCRIPTIONS = gql`
  query activeUserSubscriptions($userBase: UserBaseInput) {
    activeUserSubscriptions(user: $userBase) {
      id
      name
      planId
      createdAt
      updatedAt
      expiredDate
      status
      subscriptionHost
    }
  }
`;

export const USER_PAYMENT_TOKEN = gql`
  query paymentToken {
    paymentToken
  }
`;

export const MAKE_SUBSCRIPTION = gql`
  mutation makeSubscription(
    $nonce: String!
    $planId: String!
    $isPendingSubscription: Boolean!
    $isRenewedSubscription: Boolean!
    $maxPatients: Int
  ) {
    makeSubscription(
      nonce: $nonce
      planId: $planId
      isPendingSubscription: $isPendingSubscription
      isRenewedSubscription: $isRenewedSubscription
      maxPatients: $maxPatients
    )
  }
`;

export const UPDATE_PAYMENT_SUBSCRIPTIONS = gql`
  mutation updatePaymentSubscriptions($nonce: String!) {
    updatePaymentSubscriptions(nonce: $nonce)
  }
`;

export const UPDATE_PAYMENT_SUBSCRIPTIONS_PLAN = gql`
  mutation changeSubscriptionsPlans(
    $nonce: String!
    $planId: String!
    $maxPatients: Int
  ) {
    changeSubscriptionsPlans(
      nonce: $nonce
      planId: $planId
      maxPatients: $maxPatients
    )
  }
`;

export const CANCEL_SUBSCRIPTIONS = gql`
  mutation cancelSubscriptions {
    cancelSubscriptions
  }
`;

export const CANCEL_SUBSCRIPTIONS_FOR_CLINIC = gql`
  mutation cancelSubscriptionsForClinic(
    $ids: [String!]!
    $user: UserBaseInput!
  ) {
    cancelSubscriptionsForClinic(ids: $ids, user: $user)
  }
`;

export const SET_FREE_TRIAL_SUBSCRIPTION_FOR_CLINIC = gql`
  mutation setFreeTrialClinicSubscription(
    $clinicId: String!
    $isManualSubscribed: Boolean!
    $manualSubscribedTillDate: DateTime
  ) {
    setFreeTrialClinicSubscription(
      clinicId: $clinicId
      isManualSubscribed: $isManualSubscribed
      manualSubscribedTillDate: $manualSubscribedTillDate
    )
  }
`;

export const MAKE_SUBSCRIPTION_FOR_CLINIC = gql`
  mutation makeClinicSubscription(
    $clinicId: String!
    $fee: FeeClinic!
    $admin: AdminForClinic!
    $email: String!
    $name: String!
  ) {
    makeClinicSubscription(
      clinicId: $clinicId
      fee: $fee
      admin: $admin
      email: $email
      name: $name
    )
  }
`;

export const IS_SUBSCRIBED = gql`
  mutation isSubscribed($userId: String!, $role: Role!) {
    isSubscribed(userId: $userId, role: $role)
  }
`;

export const PATIENTS_COUNT_FOR_DOCTOR = gql`
  query patientsCount {
    count: patientsCount
  }
`;

export const ANOTHER_USER_ACCESS = gql`
  query getAnotherUserAccess($userId: String!, $userRole: Role!) {
    getUserAccess(userId: $userId, userRole: $userRole) {
      isAbleToBuyOwnSubscription
      ownSubscription {
        id
        canCancelSubscription
        expiredAt
        isActive
        isAvailableAddClinic
        isAvailableAddDoctor
        isAvailableAddPatient
        isAvailableInviteDoctor
        isAvailableInvitePatient
        isBlocked
        isExpired
        isTrial
        isCanceled
        isPending
      }
    }
  }
`;

export const USER_ACCESS = gql`
  query getUserAccess {
    getUserAccess {
      isAbleToBuyOwnSubscription
      ownSubscription {
        id
        canCancelSubscription
        expiredAt
        isActive
        isAvailableAddClinic
        isAvailableAddDoctor
        isAvailableAddPatient
        isAvailableInviteDoctor
        isAvailableInvitePatient
        isBlocked
        isExpired
        isTrial
        isCanceled
        isPending
      }
      underClinicSubscription {
        clinic {
          id
          name
        }
        isActive
        isAvailableAddPatient
        isBlocked
        isExpired
      }
      underDoctorSubscription {
        doctor {
          id
          firstName
          lastName
        }
        isActive
        isBlocked
        isExpired
      }
    }
  }
`;

export const UPDATE_BRAINTREE_PLAN = gql`
  mutation updateBraintreePlan(
    $id: String!
    $name: String!
    $description: String
    $price: String!
  ) {
    updateBraintreePlan(
      id: $id
      name: $name
      description: $description
      price: $price
    ) {
      id
      name
      description
      price
    }
  }
`;
